<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <TermsAndConditions
      :open-modal="openModal"
      :orp-details="brpDetails"
      @close-modal="closeTermsAndConditions()"
    />
    <form
      v-if="!isSuccess"
      id="login-form"
      class="login-form custom-form"
      novalidate
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <div
        class="row success-message text-center m-b-20"
      >
        <h1
          class="title md-title"
        >
          <span class="buyer-registration-welcome-message" />
        </h1>
        <p
          v-if="brpDetails.description"
          class="subtitle p-t-10 p-b-10"
        >
          {{ brpDetails.description }}
        </p>
        <p
          v-t="$t('ORP_SUB_HEADER', { applicantType })"
          class="subtitle p-b-15"
        />
      </div>

      <OpenRegistrationPageForm
        v-model="registrationForm"
        :orp-details="brpDetails"
        @on-open-terms-and-conditions="openTermsAndConditions"
      />

      <fieldset class="login-form__field login-form__field--button p-t-15">
        <SubmitButton :pending="isPending">
          {{ $t('ORP_REGISTER_BUTTON', { applicantType }) }}
        </SubmitButton>
      </fieldset>
      <transition name="backend-error-fade">
        <div
          v-show="showErrorMsg"
          class="text-center p-t-5"
        >
          <p class="text-danger">
            {{ actionStatus.error !== '' ? actionStatus.error: $t('ORP_GENERIC_ERROR', { applicantType }) }}
          </p>
        </div>
      </transition>
      <div>
        <p
          class="text-center p-t-15 prp_footer_contact"
          v-html="$t('ORP_FOOTER_CONTACT_EMAIL', { contactEmail: brpDetails.contactEmail, applicantType })"
        />
      </div>
    </form>
    <div
      v-if="isSuccess"
      class="success-message text-center"
    >
      <h1
        v-t="'THANK_YOU'"
        class="title md-title"
      />
      <p
        v-t="$t('ORP_THANK_YOU_LINE1', { applicantType })"
        class="subtitle"
      />
      <p
        v-t="'ORP_THANK_YOU_LINE2'"
        class="subtitle"
      />
    </div>
  </ValidationObserver>
</template>

<script>

import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { STATUS_PENDING, STATUS_ERROR, STATUS_SUCCESS } from '@/store/helpers';
import SubmitButton from '@/modules/auth/components/SubmitButton';
import TermsAndConditions from '../TermsAndConditions';
import OpenRegistrationPageForm from '../OpenRegistrationPageForm';

export default {
  components: {
    SubmitButton,
    TermsAndConditions,
    OpenRegistrationPageForm
  },
  props: {
    actionStatus: {
      type: Object,
      default() {
        return {};
      },
    },
    brpDetails: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: function () {
    return {  
      registrationForm: {
        email: '',
        firstName: '',
        lastName: '',
        companyName: '',
        phoneNumber: '',
        agreedToTerms: false,
      },
      openModal: false,
      applicantType: 'buyer'
    };
  },
  computed: {
    isPending() {
      return this.actionStatus.status === STATUS_PENDING;
    },
    isSuccess() {
      return this.actionStatus.status === STATUS_SUCCESS;
    },
    showErrorMsg() {
      return this.actionStatus.status === STATUS_ERROR;
    }
  },
  methods: {
    onSubmit() {
      const { email, firstName, lastName, companyName, phoneNumber, agreedToTerms  } = this.registrationForm;
      this.$emit('on-register', { email, firstName, lastName, companyName, phoneNumber, agreedToTerms });
    },
    openTermsAndConditions() {
      this.openModal = true;
    },
    closeTermsAndConditions() {
      this.openModal = false;
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
.modal.prp-terms-modal .modal-content {
  border-radius: 20px;
  background: var(--component-publisher-registration__center-bg);
}
.buyer-registration-welcome-message:before {
    content: var(--component-buyer-registration__welcome-message);
}
</style>
